<template>
    <b-modal
        centered
        content-class="participant-detail"
        footer-bg-variant="light"
        header-bg-variant="info"
        header-text-variant="white"
        id="participant-modal"
        ok-only
        scrollable
        size="lg"
    >
        <template v-slot:modal-header>
            <h2 class="modal-title">
                <span class="modal-title-text">Participant Detail</span>
            </h2>

            <hec-close-button
                @closeClick="closeModal"
                helpText="Close dialog"
                class="text-white"
            ></hec-close-button>
        </template>

        <participant-detail :participant="participant"></participant-detail>

        <template v-slot:modal-footer>
            <b-button @click="closeModal" aria-label="OK" variant="info">
                OK
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import HecCloseButton from "@/components/global/HecCloseButton";
import ParticipantDetail from "./ParticipantDetail";

export default {
    name: "ParticipantModal",
    components: {
        HecCloseButton,
        ParticipantDetail
    },
    props: {
        participant: {
            type: Object,
            default: null
        }
    },
    methods: {
        closeModal() {
            this.$bvModal.hide("participant-modal");
        }
    }
};
</script>
